import React from 'react';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import InfoIcon from '@mui/icons-material/Info';

import DialogShell from '@/components/DialogShell';
import { useUIStore } from '@/stores/useUIStore';

const MarcInfoDialog: React.FC = () => {
  const open = useUIStore((s) => s.marcInfoDialogOpen);
  const closeDialog = useUIStore((s) => s.closeDialog);

  const handleClose = () => closeDialog('marcInfoDialog');

  return (
    <DialogShell
      open={open}
      onClose={handleClose}
      title="Marc Export"
      titleColor="info.main"
      icon={<InfoIcon color="info" sx={{ fontSize: 28 }} />}
      maxWidth={480}
      actions={
        <Button variant="contained" color="info" onClick={handleClose}>
          OK
        </Button>
      }
    >
      <Typography variant="body2">
        Unzip the downloaded folder and run <code>run_job_locked.bat</code>.
        <br />
        On Linux, run <code>run_job_locked.sh</code>.
      </Typography>
    </DialogShell>
  );
};

export default MarcInfoDialog;
